const queryKeys = {
  libListPano: 'libListPano',
  libListPVideo: 'libListPVideo',
  libListMatrix: 'libListMatrix',
  libListImage: 'libListImage',
  libListAudio: 'libListAudio',
  libListVideo: 'libListVideo',
  libListSeqFrame: 'libListSeqFrame',
  libItemArticle: 'libItemArticle',
  libSpace: 'libSpace',
  libListDoc: 'libListDoc',
  libListArticle: 'libListArticle',
  libListModel3d: 'libModel3d',
};

export default queryKeys;
